
  import { defineComponent, PropType } from 'vue';

  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';

  import {
    TPortalVisitsCountTableItem,
    TStatisticsPortalFilter,
    TStatisticsPortalVisitsCountByTimeChart,
  } from '@/modules/admin/types/statistics/statistics-portal';

  import {
    STATISTICS_PORTAL_ACTIONS_NAME,
    STATISTICS_PORTAL_GETTERS_NAME,
    STATISTICS_PORTAL_MUTATIONS_NAME,
  } from '../../../store/statisticsPortal/name';
  import { getStatisticsChartWithLegendsConfigs } from '../../../utils/statisticsCharts';
  import { TChartBaseConfig } from '../charts/chartTypes';
  import StatisticsVerticalColumnChart from '../charts/StatisticsVerticalColumnChart.vue';
  import StatisticsByTimeTabs from '../StatisticsByTimeTabs.vue';

  export default defineComponent({
    name: 'StatisticsPortalVisitsCountByTimeTab',
    components: {
      TableTree,
      StatisticsVerticalColumnChart,
      StatisticsByTimeTabs,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
    data(): {
      tableConfig: TTableTreeConfig<TPortalVisitsCountTableItem>;
      chartConfigs: TChartBaseConfig<TStatisticsPortalVisitsCountByTimeChart>;
    } {
      return {
        tableConfig: {
          columns: [
            {
              field: 'name',
              title: 'Период/Группа пользователей',
            },
            {
              field: 'visitsCount',
              title: 'Количество посещений',
              textAlign: 'right',
              width: 188,
            },
          ],
          storePaths: {
            action: STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByTimeTable,
            mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setVisitsCountByTimeTable,
            getter: STATISTICS_PORTAL_GETTERS_NAME.getVisitsCountByTimeTable,
          },
          pagination: {
            size: 12,
          },
        },
        chartConfigs: getStatisticsChartWithLegendsConfigs({
          action: STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByTimeChartData,
          mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setVisitsCountByTimeChartData,
          getter: STATISTICS_PORTAL_GETTERS_NAME.getVisitsCountByTimeChartData,
        }),
      };
    },
  });
